import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { Button } from "@mui/material";
import { SaveButton, CancelButton } from "../../common/Buttons";

export const CustomEditActionButtons = ({ table, row, handleUpdateOrder }) => {
  const handleCancel = () => {
    table.setEditingRow(null);
  };
  const handleSave = () => {
    const values = table.getState().editingRow || {};
    const orderId = row.original.order_id;
    const rowStatus = row.original.status;
    const beforeCalStatus = rowStatus === 1;
    const obj = {
      order_name: values.order_name ?? row.original.order_name,
      color: values.color ?? row.original.color,
      item_id: values.item_id ?? row.original.item_id,
      qty: values.qty ?? row.original.qty,
      start_date: values.start_date ?? row.original.start_date,
      due_date: values.due_date ?? row.original.due_date,
      priority: values.priority ?? row.original.order_priority,
      order_id: orderId,
    };
    const isItemIdNotUpdated =
      !values.item_id || values.item_id === row.original.item_id;
    const isQtyNotUpdated =
      !values.qty || Number(values.qty) === row.original.qty;
    const isStartDateNotUpdated =
      !values.start_date || row.original.start_date === values.start_date;
    const isDueDateNotUpdated =
      !values.due_date || row.original.due_date === values.due_date;
    const onlyWillOrderListUpdate =
      isItemIdNotUpdated &&
      isQtyNotUpdated &&
      isStartDateNotUpdated &&
      isDueDateNotUpdated;
    if (onlyWillOrderListUpdate) {
      handleUpdateOrder({ values: obj, table });
    } else if (beforeCalStatus) {
      handleUpdateOrder({ values: obj, table });
    } else {
      handleUpdateOrder({ values: obj, table });
    }
    table.setEditingRow(null);
  };
  return (
    <div style={{ display: "flex", gap: "4px" }}>
      <SaveButton onClick={handleSave} />
      <CancelButton onClick={handleCancel} />
      {/* <Button
        onClick={handleSave}
        color="primary"
        variant="contained"
        startIcon={<SaveIcon />}
      >
        저장
      </Button>
      <Button
        onClick={handleCancel}
        color="error"
        variant="contained"
        startIcon={<CancelIcon />}
      >
        취소
      </Button> */}
    </div>
  );
};

export default CustomEditActionButtons;
